import { helpers } from 'vuelidate/lib/validators';
import messages from './messages';
import formatDataBR from '@/plugins/filters/formatDataBR';

const checkValue = (value) => typeof value === 'undefined' || value === null || value === '';

export function getMessages(value, param) {
  if (checkValue(value)) { return ''; }

  let message = messages[value];
  for (let key in param) {
    if (key !== 'type') { message = message.replace(`:${key}`, ((message.indexOf(':data') >= 0) ? formatDataBR(param[key]) : param[key]) ); }
  }

  return message;
}

export const alphaSpace = helpers.withParams({ type: 'alphaSpace' }, (value) => {
  if (checkValue(value)) { return true; }
  return /^[a-zA-Z\u00C0-\u017F \.]*$/.test(value);
});

export const alphaNumSpace = helpers.withParams({ type: 'alphaSpace' }, (value) => {
  if (checkValue(value)) { return true; }
  return /^[a-zA-Z0-9\u00C0-\u017F \.]*$/.test(value);
});

export const alphaNumSpaceEnter = helpers.withParams({ type: 'alphaSpace' }, (value) => {
  if (checkValue(value)) { return true; }
  return /^[a-zA-Z0-9\u00C0-\u017F\s\n°ºª.,:;`´'"*!?<>|_()\-+=/\\[\]{}#$%&]*$/.test(value);
});

export const lessThen = (data) => {
  if (checkValue(data)) { return true; }
  return helpers.withParams({ type: 'lessThen', data }, (value) => {    
    if (checkValue(value)) { return true; }        
    if (value.length == 10)  {
      let date = value.split('/');
      return new Date(`${date[2]}-${date[1]}-${date[0]}T00:00:01`) < new Date(`${data}T00:00:01`);     
    }
  });
}

export const words = helpers.withParams({ type: 'words' }, (value) => {
  if (value.trim() == '') { return false; }
  return /^([a-zA-ZáéíóúâêîôûàçÁÉÍÓÚÂÊÎÔÛÇ]\s*)+$/.test(value);
});

export const before = (data) => {
  if (checkValue(data)) { return true; }

  return helpers.withParams({ type: 'before', data }, (value) => {
    if (checkValue(value)) { return true; }
    let date = value.split('/');
    return new Date(`${date[2]}-${date[1]}-${date[0]}T00:00:01`) < new Date(`${data}T00:00:01`);
  });
}
